/* Copyright 2013 - 2022 Waiterio LLC */
import React from 'react'
import { hydrate } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import ErrorBoundaryGlobal from '@waiterio/components/ErrorBoundaryGlobal.js'
import ScrollToTop from '@waiterio/components/ScrollToTop.js'
import getInitialContext from './getInitialContext.js'
import App from './App.js'

const initialContext = window.__PRELOADED_CONTEXT__ || getInitialContext()

hydrate(
  <ErrorBoundaryGlobal>
    <BrowserRouter>
      <ScrollToTop />
      <App initialContext={initialContext} />
    </BrowserRouter>
  </ErrorBoundaryGlobal>,
  document.getElementById('root'),
)
